/**
 * Preparo do que o app grava no Firestore (saveToFirebase / batch).
 *
 * - removeUndefinedFields: tira undefined sem transformar Timestamp, Date, GeoPoint,
 *   FieldValue etc. em mapa comum (isso mudava o tipo do campo no banco e, em
 *   vendors.location, fazia a regra recusar a gravação inteira da loja).
 * - omitServerOnlyStoreFields: campos da loja que só o servidor altera nunca vão
 *   na gravação do app (as regras recusam qualquer mudança neles).
 */

function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (value === null || typeof value !== 'object') return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}

export function removeUndefinedFields<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map((item) => removeUndefinedFields(item)).filter((item) => item !== undefined) as unknown as T;
  }
  if (!isPlainObject(obj)) return obj;
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(obj)) {
    if (value !== undefined) result[key] = removeUndefinedFields(value);
  }
  return result as T;
}

const SERVER_ONLY_FIELDS: Record<string, readonly string[]> = {
  vendors: ['location', 'locationStatus', 'salesPaused'],
  suppliers: ['salesPaused'],
};

export function omitServerOnlyStoreFields<T>(collectionName: string, data: T): T {
  const fields = SERVER_ONLY_FIELDS[collectionName];
  if (!fields || !isPlainObject(data)) return data;
  if (!fields.some((f) => f in data)) return data;
  const rest: Record<string, unknown> = { ...data };
  for (const f of fields) delete rest[f];
  return rest as T;
}
